import { useState } from 'react';
import { faqs } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

function buildFaqSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-background-100/60 py-14 md:py-20" aria-labelledby="faq-title">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(buildFaqSchema()) }} />
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr] lg:gap-12">
          <div>
            <SectionHeading eyebrow="FAQ & Guide" title="关于吃瓜视界，你可能想问" desc="关于平台定位、内容更新、真实性、投稿与版权，这里集中回答了大家问得最多的几个问题。" />
            <div className="hidden rounded-2xl border border-background-200 bg-background-50 p-5 lg:block">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-customer-service-2-line text-accent-600" style={{ width: 20, height: 20, fontSize: 20 }} />
                还有疑问？
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                没找到想要的答案？可以直接填写页面底部的投稿 / 联系表单，审核团队会在 24 小时内给你答复。
              </p>
              <a
                href="#contact"
                className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                联系客服
                <i className="ri-arrow-right-line" style={{ width: 15, height: 15 }} />
              </a>
            </div>
          </div>

          <div>
            {faqs.map((f, i) => {
              const active = open === i;
              return (
                <div key={f.q} className={`mb-3 overflow-hidden rounded-xl border transition-colors ${active ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50/70'}`}>
                  <button
                    type="button"
                    onClick={() => setOpen(active ? -1 : i)}
                    aria-expanded={active}
                    className="flex w-full items-center gap-3 px-4 py-4 text-left md:px-5"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        active ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-700'
                      }`}
                    >
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className={`flex-1 text-sm font-semibold md:text-base ${active ? 'text-foreground-950' : 'text-foreground-800'}`}>{f.q}</span>
                    <i
                      className={`ri-add-line shrink-0 text-primary-500 transition-transform duration-300 ${active ? 'rotate-45' : ''}`}
                      style={{ width: 20, height: 20, fontSize: 20 }}
                    />
                  </button>
                  {active && (
                    <div className="border-t border-background-100 px-4 pb-5 pt-4 md:px-5">
                      <p className="text-sm leading-relaxed text-foreground-600 md:pl-10">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}